export default __webpack_public_path__ + "static/tuition-scholarships-3504ffee29f589ec0288eeaa2198d1ef.jpg";